<template>
  <v-container class="fill-height"
               fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">
        <v-form @submit.prevent="submit"
                :disabled="form.busy"
                autocomplete="on"
                ref="form">
          <v-card tile
                  class="mb-4">
            <v-card-title class="text-uppercase justify-center">
              <v-img src="/v2/images/mobilelocker_logo.png"
                     alt="Mobile Locker">
              </v-img>
              Single Sign-On Test
            </v-card-title>
            <v-progress-linear indeterminate
                               v-if="form.busy">
            </v-progress-linear>
            <v-card-text class="pb-0">

              <v-text-field v-model="form.email"
                            type="email"
                            placeholder="Your email address"
                            autocomplete="username"
                            :disabled="form.busy"
                            :rules="[rules.required, rules.email]"
                            :error-messages="form.errors.get('email')">
              </v-text-field>

              <div v-if="error"
                   class="red--text">
                {{ error }}
              </div>
            </v-card-text>
            <v-card-actions class="justify-space-between">
              <v-btn type="submit"
                     :disabled="form.busy || !form.email"
                     block
                     color="primary">
                Test Single Sign-On
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';
import DynamicsDialog from './components/DynamicsDialog';

export default {
  components: {DynamicsDialog},
  mixins: [formValidation],
  metaInfo() {
    this.$store.commit('setTitle', `Single Sign-On Test`);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      error: null,
      form: new Form({
        email: '',
      }),
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'isAdmin',
      'user',
    ]),
  },
  created() {

  },
  methods: {
    async submit() {
      if (this.form.busy) {
        return;
      }
      if (!this.form.email) {
        return;
      }
      if (!this.validateForm()) {
        return;
      }
      this.form.busy = true;
      const url = `/login/workos/auth?email=${encodeURIComponent(this.form.email)}`;
      //console.log(`Redirecting to ${url}`);
      window.location.assign(url);
    }
  }
}
</script>
